import { CertificationEvaluationEventAction } from './pns-event-actions';

export interface CertificationEvaluationEvent {
  id: string;
  type: PnsEventType;
  certificationCode: string;
  revisionNumber: string;
  referenceId: string;
  referenceName: string;
  user: UserEvent;
  executedAt: string;
  actions: CertificationEvaluationEventAction[];
}

export interface UserEvent {
  email: string;
  firstName: string;
  lastName: string;
}

export enum PnsEventType {
  Create = 'CREATE',
  UpdateUsers = 'UPDATE_USERS',
  UpdateValues = 'UPDATE_VALUES',
  Transition = 'TRANSITION',
  Import = 'IMPORT',
  ImportValues = 'IMPORT_VALUES',
}
